function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".identities_svg__h,.identities_svg__i{fill:#fff;stroke-width:2px}.identities_svg__f,.identities_svg__i{stroke-linecap:round}.identities_svg__f{fill:none}.identities_svg__i{stroke-linejoin:round}.identities_svg__f,.identities_svg__h,.identities_svg__i{stroke:#d32f2f}.identities_svg__f{stroke-width:3px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.739 68.838a22.994 22.994 0 010-32.525L36.313 8.739A23 23 0 1168.84 41.264L41.264 68.838a22.994 22.994 0 01-32.525 0z",
  fill: "#ffd5d5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-104 -21)",
  strokeWidth: 2,
  stroke: "#1d1f2c"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57,
  height: 49,
  rx: 3,
  transform: "translate(113 35)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M113 44.533h56.49",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "none"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-104 -21)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 9,
  rx: 1,
  transform: "translate(121 67)",
  fill: "none",
  strokeWidth: 2,
  stroke: "#1d1f2c"
}), /*#__PURE__*/React.createElement("path", {
  className: "identities_svg__f",
  d: "M138 71.554v-.05M144 71.554v-.05M126 71.554v-.05M132 71.554v-.05"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M149 60h17v19h-17z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16 20)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "identities_svg__h",
  width: 8,
  height: 14,
  rx: 4,
  transform: "translate(137 42)"
}), /*#__PURE__*/React.createElement("g", {
  className: "identities_svg__i",
  transform: "translate(134 47)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 10,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 12,
  height: 8,
  rx: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M141 52.734V51",
  stroke: "#d32f2f",
  strokeLinecap: "round",
  fill: "none",
  strokeWidth: 2
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-104 -20)"
}, /*#__PURE__*/React.createElement("path", {
  className: "identities_svg__i",
  d: "M143 61.979l-.047.021v-.045a27.236 27.236 0 01-9.174-7.338c-4.2-5.205-3.977-14.723-3.977-14.723v-7.4l13.15-3.461v-.031l.047.014.051-.014v.029l13.148 3.461v7.4s.227 9.518-3.979 14.723a27.306 27.306 0 01-9.17 7.338v.045a.524.524 0 01-.049-.019z"
}), /*#__PURE__*/React.createElement("path", {
  className: "identities_svg__h",
  d: "M143 43a6 6 0 016 6v1.333a.667.667 0 01-.667.667h-10.666a.667.667 0 01-.667-.667V49a6 6 0 016-6z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "identities_svg__h",
  cx: 4,
  cy: 4,
  r: 4,
  transform: "translate(139 35)"
}));

var SvgIdentities = function SvgIdentities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default "data:image/svg+xml;base64,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";
export { SvgIdentities as ReactComponent };